/**
 * Crea uno store vuoto
 * 
 * deve essere sovrascritto con
 * 
 * store.replaceReducer
 * 
 * della build corretta
 */
import { configureStore } from '@reduxjs/toolkit'
import { persistReducer, persistStore } from 'redux-persist'

// import logger from 'redux-logger' // abilitare per il logger dello stato di redux
import thunk from 'redux-thunk'
import storage from 'redux-persist/lib/storage'

import * as Constants from '../costants'

// possibili alternative
import { bicycleReducer } from '../page/bicycle/BicycleSilce'
import { commercialhReducer } from '../page/commercial/CommercialPageSilce'
import { cyberReducer } from '../page/cyber/CyberPageSilce'
import { fireReducer } from '../page/fire/FirePageSilce'
import { homeReducer } from '../page/home/HomePageSilce'
import { healthReducer } from '../page/health/HealthPageSilce'
import { householderReducer } from '../page/householder/HouseholderPageSilce'
import { injuryReducer } from '../page/injury/InjuryPageSilce'
import { lifeReducer } from '../page/life/LifePageSilce'
import { microcarReducer } from '../page/microcar/MicroCarSilce'
import { petReducer } from '../page/pets/PetPageSilce'
import { profReducer } from '../page/professional/ProfessionalPageSilce'
import { shipReducer } from '../page/ship/ShipPageSilce'
import { smartPhoneReducer } from '../page/smartphone/SmartPhonePageSilce'
import { travelReducer } from '../page/travel/TravelPageSilce'
import { vintagecarReducer } from '../page/vintagecar/VintageCarSilce'
import { vintagebikeReducer } from '../page/vintagebike/VintageBikeSilce'

let actualReducer : any
let sotreName

switch (Constants.BUILD_PROFILE) {
    case 'BICYCLE':
        actualReducer = bicycleReducer
        sotreName =  'bicycle'
        break
    case 'COMMERCIAL_VEHICLE':
        actualReducer = commercialhReducer
        sotreName =  'commercial'
        break
    case 'CYBER':
        actualReducer = cyberReducer
        sotreName =  'cyber'
        break
    case 'FIRE':
        actualReducer = fireReducer
        sotreName =  'fire'
        break
    case 'HEALTH':
        actualReducer = healthReducer
        sotreName =  'healt'
        break
    case 'HOME':
        actualReducer = homeReducer
        sotreName =  'home'
        break
    case 'HOUSEHOLDER':
        actualReducer = householderReducer
        sotreName = 'householder'
        break
    case 'INJURY':
        actualReducer = injuryReducer
        sotreName = 'injury'
        break
    case 'MICROCAR':
        actualReducer = microcarReducer
        sotreName =  'microcar'
        break
    case 'LIFE':
        actualReducer = lifeReducer
        sotreName =  'life'
        break
    case 'PETS':
        actualReducer = petReducer
        sotreName =  'pets'
        break
    case 'PROFESSIONAL':
        actualReducer = profReducer
        sotreName =  'professional'
        break
    case 'SMART_PHONE':
        actualReducer = smartPhoneReducer
        sotreName =  'smart'
        break
    case 'SHIP':
        actualReducer = shipReducer
        sotreName =  'ship'
        break
    case 'TRAVEL':
        actualReducer = travelReducer
        sotreName =  'travel'
        break
    case 'VINTAGEBIKE':
        actualReducer = vintagebikeReducer
        sotreName =  'vintagebike'
        break
    case 'VINTAGECAR':
        actualReducer = vintagecarReducer
        sotreName =  'vintagecar'
        break

    default:
        actualReducer = undefined
        sotreName =  ''
        break
}

const persistConfig = {
  key: sotreName,
  storage,
}

const persistedReducer = persistReducer( persistConfig, actualReducer)

export const store = configureStore({
    reducer: persistedReducer,
    middleware: [thunk], // se voglio il log dello stato di redux --> [thunk, logger]
    devTools: process.env.NODE_ENV !== 'production',
})

export const pStore = persistStore(store)


